import { ZoomClient } from '@/Types/zoom';
import React from 'react';
export default React.createContext<ZoomClient>(null as any);
